<template>
  <div class="footer">
    <div class="grid">
      <div class="footerleft">
        <b>Computus BV</b>
        <br />KvK nr. 71165126
        <br />BTW nr. NL858605533B01
        <br />
        <router-link :to="{name: 'contact'}">Contactformulier</router-link>
      </div>
      <div class="footerright">
        <b>Vestigingsadres</b>
        <br />Opijnen
        <br />Nederland
        <br />
        website: <a href="https://computus.nl">computus.nl</a>
      </div>
    </div>
    <div class="copyright">&copy; {{ new Date().getFullYear() }} Computus B.V.</div>
  </div>
</template>

<script>
export default {
  name: "footer",
  props: [],
  components: {}
};
</script>

<style scoped>
.footer {
  font-size: 10pt;
  padding: 5px;
  background-color: #ccd875;
}

.grid {
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 200px auto 200px;
  grid-template-areas: "footerleft . footerright";
}

.footerleft {
  grid-area: footerleft;
}

.footerright {
  grid-area: footerright;
  text-align: right;
}

.copyright {
  width: 100%;
  text-align: center;
  font-size: 10pt;
}
</style>